"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UIUtils = /** @class */ (function () {
    function UIUtils() {
    }
    UIUtils.InjectFontWOFF = function (fntWoffBase64, fntFamily) {
        var newStyle = document.createElement("style");
        newStyle.appendChild(document.createTextNode("\n                @font-face {\n                    font-family: '" + fntFamily + "';\n                    src: url(data:application/x-font-woff;charset=utf-8;base64," + fntWoffBase64 + ") format('woff');\n                }\n            "));
        document.head.appendChild(newStyle);
    };
    ;
    UIUtils.getCurrentUTCOffsetHours = function () {
        return -new Date().getTimezoneOffset() / 60;
    };
    UIUtils.IProp2Str = function (property) {
        var chaine = property.toString();
        var arr = chaine.match(/[\s\S]*{[\s\S]*\.([^\.; ]*)[ ;\n]*}/);
        return arr[1];
    };
    ;
    UIUtils.getVariableLongName = function (name) {
        var varExtractor = new RegExp("return (.*);");
        var m = varExtractor.exec(name + "");
        if (m == null)
            throw new Error("The function does not contain a statement matching 'return variableName;'");
        return m[1];
    };
    UIUtils.getVariableShortName = function (getVar) {
        var varExtractor = new RegExp("(.*);");
        var m = varExtractor.exec(getVar + "");
        if (m == null) {
            throw new Error("The function does not contain a statement matching 'return variableName;'");
        }
        var fullMemberName = m[1];
        var memberParts = fullMemberName.split('.');
        return memberParts[memberParts.length - 1];
    };
    UIUtils.generateUUID = function () {
        var d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now();
        }
        var uuid = "xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            // tslint:disable-next-line:no-bitwise
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            // tslint:disable-next-line:no-bitwise
            return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    };
    ;
    UIUtils.isMobile = function () {
        var isMobile = false; //initiate as false
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
            isMobile = true;
        return isMobile;
    };
    UIUtils.isIOS = function () {
        var iDevices = [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ];
        if (!!navigator.platform) {
            while (iDevices.length) {
                if (navigator.platform === iDevices.pop()) {
                    return true;
                }
            }
        }
        return false;
    };
    UIUtils.LoadExternalTextContent = function (url, onSuccess, onError) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.timeout = 30000;
        xhr.onreadystatechange = function () {
            if (this.readyState !== 4) {
                return;
            }
            ;
            if (this.status !== 200) {
                if (onError) {
                    onError(this.status);
                }
            }
            ;
            onSuccess(this.responseText);
        };
        xhr.send();
    };
    UIUtils.GetContentHeight = function (content) {
        var _ret = "";
        var _retN = 0;
        var _startMark = "_INFO_PAGE_HEIGHT_START_";
        var _start = content.indexOf(_startMark);
        var _end = content.indexOf("_INFO_PAGE_HEIGHT_END_");
        for (var i = _start + _startMark.length; i < _end; i++) {
            _ret = _ret + content[i];
        }
        try {
            _retN = parseInt(_ret);
        }
        catch (ex) {
            console.log("parse page height error -> " + ex);
        }
        return _retN;
    };
    UIUtils.GetScreenWidth = function () {
        var _w;
        if (this.isMobile()) {
            _w = window.outerWidth;
            if (this.isIOS()) {
                _w = window.innerWidth;
            }
        }
        else {
            _w = window.innerWidth;
        }
        return _w;
    };
    UIUtils.GetScreenHeight = function () {
        var _h;
        if (this.isMobile()) {
            _h = window.outerHeight;
            if (this.isIOS()) {
                _h = window.innerHeight;
            }
        }
        else {
            _h = window.innerHeight;
        }
        return _h;
    };
    UIUtils.FormatStr = function (template, params) {
        var tmp = template;
        for (var i = 0; i < params.length; i++) {
            tmp = tmp.replace("{" + i + "}", params[i]);
        }
        return tmp;
    };
    UIUtils.ArrStrToString = function (dt, separator) {
        var _sp = ",";
        var _ret = "";
        if (separator) {
            _sp = separator;
        }
        for (var i = 0; i < dt.length; i++) {
            if (i != 0) {
                _ret += _sp;
            }
            _ret += dt[i];
        }
        return _ret;
    };
    UIUtils.CollectUnique = function (src, exists) {
        var _ret = [];
        for (var i = 0; i < exists.length; i++) {
            _ret.push(exists[i]);
        }
        for (var i = 0; i < src.length; i++) {
            var found = false;
            for (var j = 0; j < _ret.length; j++) {
                if (_ret[j] === src[i]) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                _ret.push(src[i]);
            }
        }
        return _ret;
    };
    UIUtils.getLastYear = function () {
        var d = new Date();
        var from = d.setMonth(d.getMonth() - 12);
        return new Date(from);
    };
    UIUtils.getLastMonth = function () {
        var d = new Date();
        var from = d.setMonth(d.getMonth() - 1);
        return new Date(from);
    };
    UIUtils.getLastWeek = function () {
        var dateOffset = (24 * 60 * 60 * 1000) * 7;
        var myDate = new Date();
        myDate.setTime(myDate.getTime() - dateOffset);
        return myDate;
    };
    UIUtils.getLastDay = function () {
        var dateOffset = (24 * 60 * 60 * 1000) * 1;
        var myDate = new Date();
        myDate.setTime(myDate.getTime() - dateOffset);
        return myDate;
    };
    UIUtils.getToday = function () {
        var myDate = new Date();
        myDate.setHours(0, 0, 0, 0);
        return myDate;
    };
    UIUtils.Base64Encode = function (data) {
        return btoa(data);
    };
    UIUtils.Base64Decode = function (data) {
        return atob(data);
    };
    UIUtils.Base64EncodeU = function (data) {
        return btoa(unescape(encodeURIComponent(data)));
    };
    //https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa
    UIUtils.Base64DecodeU = function (data) {
        return decodeURIComponent(escape(atob(data)));
    };
    UIUtils.formatCurrency = function (n) {
        return n.toFixed(2).replace(/./g, function (c, i, a) {
            return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
        });
    };
    UIUtils.bool2Str = function (val, yesTxt, noTxt) {
        if (val) {
            return yesTxt;
        }
        else {
            return noTxt;
        }
    };
    UIUtils.int2StrZeroStart = function (val) {
        if (val < 10) {
            return "0" + val;
        }
        else {
            return "" + val;
        }
    };
    UIUtils.bool2Int = function (val) {
        if (val) {
            return 1;
        }
        else {
            return 0;
        }
    };
    return UIUtils;
}());
exports.UIUtils = UIUtils;



//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/UIUtils.ts
// module id = 3
// module chunks = 0